module.exports = __webpack_public_path__ + "static/home-office-carousel-befc660a64075c0466ec708bd1ddb2e7.svg";